//
//
//
//
//
//

import XLSX from "xlsx"; // import xlsx
import axios, { CancelToken } from "axios";

export default {
  data() {
    return {
      menu: "",
      year: "",
      selDivision: "",
      selTeam: "",
      selSales: "",
    };
  },
  async mounted() {
    // this.menu = this.$route.params.menu;
    // this.year = this.$route.params.year;
    // this.selDivision = this.$route.params.selDivision;
    // this.selTeam = this.$route.params.selTeam;
    // this.selSales = this.$route.params.selSales;

    this.year = '2021';
    this.selDivision = '';
    this.selTeam = '';
    this.selSales = "'817','690'";
  },
  methods: {
    export2() {
      window.open(
        `http://qbi.nanyangtextile.com:8080/oe?year=${this.year}&sale=${this.selSales}&team=${this.selTeam}&division=${this.selDivision}`,
        `_export`
      );
    },
    ExportExcel() {
      let params = new FormData();
      // params.append("menu", this.menu);
      params.append("year", this.year);
      params.append("division", this.selDivision);
      params.append("team", this.selTeam);
      params.append("sale", this.selSales);
      console.log(`http://127.0.0.1:8080/oe`);
      axios
        .post(`http://127.0.0.1:8080/oe`, params)
        .then((response) => {
          console.log(response.data);
          // const dataWS = XLSX.utils.json_to_sheet(response.data);
          // const wb = XLSX.utils.book_new();
          // XLSX.utils.book_append_sheet(wb, dataWS);
          // XLSX.writeFile(wb, "export-OE.xlsx");
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
